import React from 'react';
import { Bookmark, BookmarkCheck } from 'lucide-react';
import { useSaved } from '../context/SavedContext';

// variant: 'icon' (round button, e.g. on cards) or 'pill' (labelled button)
const SaveButton = ({ item, variant = 'icon', className = '' }) => {
  const { isSaved, toggle } = useSaved();
  const saved = isSaved(item.ref_id);

  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(item);
  };

  if (variant === 'pill') {
    return (
      <button
        onClick={handle}
        aria-pressed={saved}
        className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[14px] font-semibold transition-colors ${
          saved
            ? 'bg-[#2F663C] text-white'
            : 'border border-[#2F663C]/40 text-[#2F663C] hover:bg-[#2F663C] hover:text-white'
        } ${className}`}
      >
        {saved ? <BookmarkCheck className="w-4 h-4" /> : <Bookmark className="w-4 h-4" />}
        {saved ? 'Saved to planner' : 'Save to planner'}
      </button>
    );
  }

  return (
    <button
      onClick={handle}
      aria-pressed={saved}
      aria-label={saved ? 'Remove from planner' : 'Save to planner'}
      title={saved ? 'Saved — click to remove' : 'Save to planner'}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full backdrop-blur-sm transition-colors ${
        saved
          ? 'bg-[#2F663C] text-white'
          : 'bg-white/90 text-[#1B1D21] hover:bg-white shadow-sm'
      } ${className}`}
    >
      {saved ? <BookmarkCheck className="w-[18px] h-[18px]" /> : <Bookmark className="w-[18px] h-[18px]" />}
    </button>
  );
};

export default SaveButton;
